<template>
    <div class="d-input-group form-check form-switch" :class="[{ disabled: disabled }, _variant, the_size] ">
      <span v-if="title" class="title">{{ title }}</span>
      <div class="input-field input-switch-holder" :class="[_full_width]">
        <div class="off-text switch-text"><d-text>{{ offtext }}</d-text></div>
        <div class="form-switch-switch" >
          <label class="form-check-label" for="flexSwitchCheckDefault"></label>
          <input class="form-check-input" type="checkbox" role="switch" aria-label="Small"
            aria-describedby="inputGroup-sizing-default" v-model="model" :disabled="disabled" 
            @change="OnChange()" />
        </div>
         <div class="on-text switch-text"><d-text>{{ ontext }}</d-text></div>
      </div>
      <span v-if="message" class="message" :class="_message_color_class">{{ message }}</span>
    </div>
  </template>
  
  <script setup>
  import { computed, defineEmits, defineModel, defineProps } from 'vue';
  
   
  const emit = defineEmits(['change']);
  
  const model = defineModel();
  
  const props = defineProps({
    title: {
      type: String,
      required: false
    }, 
    ontext: {
      type: String,
      required: false
    },
    offtext: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    },    
    disabled: {
      type: Boolean,
      required: false
    },
    variant: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    fullwidth: {
      type: Boolean,
      required: false
    },
  });
  
const valid_size = ['sm', 'md', 'lg', 'xl', 'xxl'];

  // COMPUTED
  
  const _variant = computed(() => {
    return props.variant ?? '';
  });
  
  const _message_color_class = computed(() => {
    if (!_variant.value) return;
  
    return 'text-' + _variant.value;
  });
  
const the_size = computed(() => {
    if (valid_size.includes(props.size))
        return props.size;
    return "";
  });

const _full_width = computed(() => {
    return props.fullwidth ? 'justify-content-between' : '';
  });

  // FUNCTIONS
  
  const OnChange = () => {
    emit('change', model);
  };
  
  </script>